import React, { useState, useEffect, useContext } from 'react'
import { withNamespaces } from 'react-i18next'
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import FormControl from '@material-ui/core/FormControl'
import i18next from 'i18next'
import TextField from "@material-ui/core/TextField"
import Button from 'react-bootstrap-button-loader'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types'
import { GetLanguage } from '@utils/language';
import { updateCommentAndDenyRequest } from '@actionsSup/approvalCentral';
import { makeStyles } from '@material-ui/core/styles';
import styles from '@styles/approvalCentral.module.css'
import { messagesTypes } from '@utils/constants';
import { MessageContext } from '@/MessageProvider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    toolBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    titleTemplate: {
        fontSize: '20px',
        '@media (max-width: 600px)': {
            fontSize: '15px',
        }
    }
}));

function DenyWithCommitRequestForm(props) {

    const classes = useStyles();
    const { dispatch } = useContext(MessageContext);
    const { open, setOpen, centralApprovalId, requestId, load } = props;
    const [locale, setLocale] = useState('fr');
    const [comment, setComment] = useState(null);
    const [isPosting, setIsPosting] = useState(false);

    useEffect(() => {
        const language = GetLanguage();
        setLocale(language);        
    })

    useEffect(() => {
        resizeForm();
    }, []);

    const onChangeComment = (event) => {
        setComment(event.target.value);
    }

    const resizeForm = () =>  {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const header = document.querySelector('div[data-id=headerRequest]').offsetHeight;
            const offSet = 50;

            const customHeight = height - header - titleBar - offSet;

            const element = document.querySelector('#divForm');

            if (element !== null) {
                element.style.height = `${customHeight}px`;
                element.style.overflowX = 'hidden';
            }
        }, 1000);
    }

    const validateForm = () => {
        return new Promise(resolve => {

            let error = false;

            if (!comment?.trim()) {
                dispatch({ type: messagesTypes.CUSTOMERROR, payload: i18next.t('approvalCentral:message.refusalComent') });
                error = true;
            }

            resolve(!error);
        });
    }

    const handleSaveClick = async () => {

        setIsPosting(true);
        const isValid = await validateForm();
        
        if (isValid) {
            const result = await updateCommentAndDenyRequest(centralApprovalId, requestId, comment);

            if (result === undefined) {
                dispatch({ type: messagesTypes.GENERICERROR});
                setIsPosting(false);
                return;
            } else if (result.statusCode === 0) {
                dispatch({ type: messagesTypes.SUCCESS, payload: i18next.t('approvalCentral:message.updateSuccess') });
            } else if (result.statusCode === 1) {
                dispatch({ type: messagesTypes.WARNING, payload: result.message ?? i18next.t('approvalCentral:message.deleteError') });
            } else if (result.statusCode === -1) {
                dispatch({ type: messagesTypes.CUSTOMERROR, payload: result.message });
                setIsPosting(false);
                return;
            } else /*if (result.statusCode === -2)*/ {
                dispatch({ type: messagesTypes.CUSTOMERROR, payload: result.message });
                setIsPosting(false);
                setOpen(false);
                return;
            }

            setIsPosting(false);
            setOpen(false);
            load();
        }
        else {
            setIsPosting(false);
        }
    }

    return (
        <Dialog fullScreen open={open} onClose={() => setOpen(false)} TransitionComponent={Transition}>
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={() => setOpen(false)} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        {i18next.t("approvalCentral:title.denyDemandComment")}
                    </Typography>
                </Toolbar>
            </AppBar>
            <div id="divForm" className={styles.divForm}>
                <LocalizationProvider language={locale}>
                    <IntlProvider locale={locale}>
                        <FormControl fullWidth className={styles.divInput}>
                            <TextField
                                id="comments"
                                label={i18next.t('approvalCentral:form.approver-comment')}
                                multiline
                                minRows={4}
                                className={styles.inputComments}
                                value={comment || ''}
                                onChange={onChangeComment}
                            />
                        </FormControl>
                    </IntlProvider>
                </LocalizationProvider>

                <FormControl fullWidth className={styles.divSaveButtonRequest}>
                    <Button
                        loading={isPosting}
                        className="saveButton required"
                        onClick={handleSaveClick}
                        variant="success"
                    >
                        {i18next.t('approvalCentral:button.save')}
                    </Button>
                </FormControl>
            </div>
        </Dialog>
    )
}

export default withNamespaces(['approvalCentral'], { wait: true })(DenyWithCommitRequestForm);

DenyWithCommitRequestForm.propTypes = {
    centralApprovalId: PropTypes.number.isRequired,
    requestId: PropTypes.number.isRequired
}